import { AiChatDrawer, useFoundryAgentRuntime } from '@strata/react-ai-chat';
import { IconButton } from '@strata/react-buttons';
import FmhAiIcon from '@strata/strata-ui/assets/illustrations/FMH-AI.svg?react';
import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';

// TODO: Plug in the AI gateway endpoint for the routing explainability agent
const AI_CHAT_ENDPOINT = '<AI_GATEWAY_ENDPOINT>';

/** FMH AI launcher: an icon button that opens the AI chat drawer. */
export const FmhAiChat = () => {
    const [isOpen, setIsOpen] = useState(false);
    const accessToken = useSelector((state) => state.auth.accessToken);

    const getHeaders = useCallback(
        () => ({ Authorization: `Bearer ${accessToken}` }),
        [accessToken],
    );
    const runtime = useFoundryAgentRuntime({
        endpoint: AI_CHAT_ENDPOINT,
        getHeaders,
        // TODO: Add initial context instructions
        instructions: `Context: TBD`,
    });

    return (
        <>
            <IconButton
                tooltip="FMH AI"
                icon={
                    <FmhAiIcon
                        role="button"
                        aria-label="FMH AI"
                        height={29}
                        width={29}
                        onClick={() => setIsOpen(true)}
                    />
                }
            />
            <AiChatDrawer isOpen={isOpen} onClose={() => setIsOpen(false)} runtime={runtime} />
        </>
    );
};
